<template>
  <div>
    <IndividualSupportComp v-bind:mobile="mobile"/>
    <FollowUs v-bind:mobile="mobile"/>
  </div>
</template>

<script>
import IndividualSupportComp from "@/components/desktop/Activities/IndividualSupportComp";
import FollowUs from '@/components/desktop/FollowUs'

  export default {
    name: 'IndividualSupport',
    props: ['mobile'],
    components: {
      IndividualSupportComp,
      FollowUs
    },
  }
</script>
